import type { BoxProps } from '@mui/material/Box';
import { forwardRef } from 'react';
import Box from '@mui/material/Box';
import { RouterLink } from 'routes/components';
import { logoClasses } from './classes';
import { LOGOS } from 'theme/core';

// ----------------------------------------------------------------------

export type LogoProps = BoxProps & {
  href?: string;
  isSingle?: boolean;
  disableLink?: boolean;
};

export const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    { width, href = '/', height, isSingle = true, disableLink = false, className, sx, ...other },
    ref
  ) => {    
    return (
      <Box
        ref={ref}
        component={RouterLink}
        href={href}
        className={logoClasses.root.concat(className ? ` ${className}` : '')}
        aria-label="Logo"
        sx={{
          flexShrink: 0,
          display: 'flex',
          verticalAlign: 'middle',
          p: 1,
          pl: 2.5,
          height: 'var(--layout-header-desktop-height)',
          ...(disableLink && { pointerEvents: 'none' }),
          ...sx,
        }}
        {...other}
      >
        <img src={LOGOS.BRAND_LOGO.src} height={"100%"} />
      </Box>
    );
  }
);

Logo.displayName = 'Logo';